import { render, staticRenderFns } from "./WineMakingNotesComponent.vue?vue&type=template&id=1bab4bae&scoped=true"
import script from "./WineMakingNotesComponent.vue?vue&type=script&lang=js"
export * from "./WineMakingNotesComponent.vue?vue&type=script&lang=js"
import style0 from "./WineMakingNotesComponent.vue?vue&type=style&index=0&id=1bab4bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab4bae",
  null
  
)

export default component.exports